import React from 'react';
function HeaderAdmin() {

    const removeAdmin = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('is_admin');
        window.location.reload();
    };
    
    return (
        <header className='bg-[#222831] p-5 relative z-50 mb-2'>
            <div className='mx-auto flex justify-between items-center relative z-50'>
                <div className='text-white relative z-50'>
                    <span className='font-semibold mr-4'>Você está no modo Admin! </span>
                </div>
                <a href='##' onClick={removeAdmin} className='text-gray-300 hover:text-red-500 transition-colors duration-300 cursor-pointer'>Sair</a>
            </div>
        </header >
    )
}

export default HeaderAdmin;
